import React from 'react';
import { observer } from "mobx-react";
import { Popup } from 'react-chat-elements';

import PaymentView from "./PaymentView";

import './PaymentForm.css';

const PaymentFormPopup = observer(({ show, onClose, onPaymentResult }) => {
    return (
        <Popup
            show={show}
            header=" "
            text={<PaymentView onPaymentResult={onPaymentResult} />}
            headerButtons={[
                {
                  type: 'close',
                  backgroundColor: 'white',
                  color: 'var(--chatbot-primary-color)',
                  text: 'X',
                  onClick: onClose,
                },
              ]}
        />
    );
});

export default PaymentFormPopup;